import { render, staticRenderFns } from "./statisticBottle.vue?vue&type=template&id=2eaa9fd6&scoped=true&"
import script from "./statisticBottle.vue?vue&type=script&lang=js&"
export * from "./statisticBottle.vue?vue&type=script&lang=js&"
import style0 from "./statisticBottle.vue?vue&type=style&index=0&id=2eaa9fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaa9fd6",
  null
  
)

export default component.exports